import React from "react";
import { NavLink } from "react-router-dom";

const ITEMS = [
  { key: "tenants", label: "Tenants", to: "/admin?tab=tenants" },
  { key: "users", label: "Users", to: "/admin?tab=users" },
  { key: "audit", label: "Audit Log", to: "/admin?tab=audit" },
  { key: "analytics", label: "Analytics", to: "/admin/analytics" },
  { key: "leads", label: "Leads", to: "/admin/leads" },
  { key: "referrals", label: "Referrals", to: "/admin/referrals" },
  { key: "nursinghomes", label: "Nursing Homes", to: "/admin/nursing-homes" },
  { key: "support", label: "Support", to: "/admin/support" },
  { key: "metrics", label: "Metrics", to: "/admin/metrics" },
];

export default function SuperAdminNav({ title = "Admin", active = "" }) {
  return (
    <>
      <header className="san-wrap">
        <div className="san-title">{title}</div>

        <nav className="san-tabs" aria-label="Super admin navigation">
          {ITEMS.map((item) => (
            <NavLink
              key={item.key}
              to={item.to}
              className={`san-tab${active === item.key ? " is-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}

          <NavLink className="san-tab san-back" to="/">
            ← Back to dashboard
          </NavLink>
        </nav>
      </header>

      <style>{`
        .san-wrap{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:16px;
          flex-wrap:wrap;
          margin-bottom:20px;
        }

        .san-title{
          margin:0;
          color:#2a0516;
          font-size:56px;
          line-height:1;
          font-weight:800;
          letter-spacing:-0.02em;
        }

        .san-tabs{
          display:flex;
          align-items:center;
          gap:10px;
          flex-wrap:wrap;
        }

        .san-tab{
          display:inline-flex;
          align-items:center;
          justify-content:center;
          min-height:40px;
          padding:0 16px;
          border-radius:12px;
          border:1px solid #cfd6e4;
          background:#fff;
          color:#2a0516;
          text-decoration:none;
          font-weight:700;
          font-size:14px;
          white-space:nowrap;
          transition:all .15s ease;
        }

        .san-tab:hover{
          border-color:#b8c2d6;
          background:#f8fafc;
        }

        .san-tab.is-active{
          background:#111827;
          border-color:#111827;
          color:#fff;
        }

        .san-back{
          background:#fff;
        }

        @media (max-width: 900px){
          .san-wrap{
            align-items:flex-start;
          }

          .san-title{
            font-size:44px;
          }
        }

        @media (max-width: 640px){
          .san-title{
            font-size:34px;
          }

          .san-tab{
            min-height:38px;
            padding:0 14px;
            font-size:13px;
          }
        }
      `}</style>
    </>
  );
}
